import { render } from "./MandatoryPage.vue?vue&type=template&id=2f208dba&scoped=true"
const script = {}

import "./MandatoryPage.vue?vue&type=style&index=0&id=2f208dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f208dba"]])

export default __exports__